function cookieFinder(cookieName) { 
    const cookie = document.cookie; 
    if (cookie) {
        const cookieValue = cookie.split("="); 
        let resutlCookie = cookieValue.find( (value) => {  
          const match = value.match(cookieName);
           if(match){ 
            return cookieName == match[0] ? true : false;
           } 
        });     
        return resutlCookie ;
        }  
    }
export default cookieFinder;